<template>
  <div>
    <div class="soar-container py-5 flex flex-col gap-y-2">
      <h2 class="text-center text-3xl text-primary border-b pb-4 border-gray-200">
        {{ $t('SmartServices') }}
      </h2>
    </div>
    <div class="soar-container">
      <swiper-container :init="false">
        <swiper-slide
          v-for="index in Array.from({ length: 7 }, (_, i) => i)"
          :key="index"
          :dir="i18n.locale.value == 'ar' ? 'rtl' : 'ltr'"
          class="w-full aspect-[9/14] relative"
        >
          <div
            class="absolute z-10 top-0 end-0 w-full h-full flex justify-start items-end touch-none pointer-events-none"
          >
            <div class="w-2 h-1/6 bg-primary mb-12"></div>
          </div>
          <div
            class="absolute z-10 top-0 start-0 w-full h-full flex justify-end items-center touch-none pointer-events-none"
          >
            <div class="w-2 h-1/6 bg-primary mb-48"></div>
          </div>
          <CarouselPanel :index="index"></CarouselPanel>
          <div
            class="bottom-0 start-0 w-full h-2 flex justify-center touch-none pointer-events-none"
          >
            <div class="w-1/3 bg-primary"></div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>

    <div class="soar-container pt-12 flex flex-col md:flex-row gap-4">
      <a
        v-for="card in cards"
        :href="card.href"
        :key="card.title"
        target="_blank"
        class="w-full md:w-1/3 shadow-sm border border-primary rounded-md bg-white flex justify-between gap-x-1"
      >
        <div
          class="w-1/3 md:w-3/6 p-4 bg-brand-gray-150 rounded-s-md flex justify-center items-center"
        >
          <i :class="card.iconClass" class="text-primary-color text-[3rem] text-primary-700" />
          <!-- <img :src="card.icon" :alt="card.title" class="w-14 h-auto" /> -->
        </div>
        <div class="w-full py-1.5 md:py-3 px-2 flex flex-col gap-y-2">
          <h2 class="text-xl font-semibold text-primary-700">{{ $t(card.title) }}</h2>
          <span class="text-xs">{{ $t(card.subtitle) }}</span>
          <div class="flex-1 flex justify-end items-end">
            <div
              class="w-8 h-8 rounded-full border border-brand-gray-300 flex justify-center items-centers"
            >
              <faChevronRight class="w-2 fill-primary me-0.5" />
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import CarouselPanel from '@/components/Landing/CarouselPanel.vue'
import faChevronRight from '@/assets/icons/faChevronRight.svg?component'
import { onMounted, computed } from 'vue'

const i18n = useI18n()

onMounted(() => {
  // swiper element
  const swiperEl = document.querySelector('swiper-container')
  // swiper parameters
  const swiperParams = {
    dir: document.documentElement.getAttribute('dir'),
    navigation: true,
    breakpoints: {
      375: {
        slidesPerView: 1,
        spaceBetween: 8
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    },
    on: {
      init() {
        // ...
      }
    }
  }

  // now we need to assign all parameters to Swiper element
  Object.assign(swiperEl, swiperParams)

  // and now initialize it
  swiperEl.initialize()
})

const cards = computed(() => {
  return [
    {
      title: 'opendata',
      subtitle: 'opendata_desc',
      iconClass: 'ica-custom-fonts-increasing',
      href: 'https://icp.gov.ae/en/open-data/'
    },
    {
      title: 'servicecard',
      subtitle: 'servicecard_desc',
      iconClass: 'ica-custom-fonts-service-card',
      href: 'https://icp.gov.ae/en/services/'
    },
    {
      title: 'customerHappinessCenters',
      subtitle: 'customerHappinessCenters_desc',
      iconClass: 'ica-custom-fonts-location-map',
      href: 'https://icp.gov.ae/en/customer-happiness-centers/'
    }
  ]
})
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
